var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddLocation = function SvgAddLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21.51q-3.776-3.271-5.661-6.089-1.887-2.817-1.887-5.173 0-3.462 2.24-5.605Q8.93 2.5 12 2.5h.404q.202 0 .404.03v1.516a5 5 0 0 0-.394-.043A6 6 0 0 0 12 3.99q-2.573 0-4.31 1.762-1.738 1.761-1.738 4.496 0 1.814 1.557 4.226T12 19.514q2.916-2.608 4.467-4.997 1.553-2.388 1.581-4.201v-.124h1.5v.123q-.03 2.348-1.91 5.145-1.882 2.798-5.638 6.05m.002-9.645q.746 0 1.276-.531.53-.532.53-1.278t-.532-1.276a1.75 1.75 0 0 0-1.278-.53q-.746 0-1.276.531-.53.532-.53 1.278t.532 1.277 1.278.53M18 8h1.5V5h3V3.5h-3v-3H18v3h-3V5h3z"
  })));
};
export default SvgAddLocation;